import React, { useEffect, useState } from "react";
import { isDuplicate } from "../utils";
import PropTypes from "prop-types";

import {
  Card,
  Divider,
  CardContent,
  Modal,
  TextField,
  Box,
  Button,
  Typography,
} from "@mui/material";

const EditKeywordModal = (props) => {
  const { keywords, handleClose, handleSubmit, keywordToEdit, open } = props;

  const { keyword: initialKeyword, keywordID } = keywordToEdit;

  const [inputValue, setInputValue] = useState(initialKeyword);

  useEffect(() => setInputValue(initialKeyword), [initialKeyword]);

  const [touched, setTouched] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setTouched(true);

    if (e.target.value.trim() === "") setErrorMessage("can't be blank");
    else if (e.target.value === initialKeyword)
      setErrorMessage("keyword hasn't changed");
    else if (isDuplicate(e.target.value, keywords))
      setErrorMessage("this keyword already exists");
    else setErrorMessage("");
  };

  const resetForm = () => {
    setInputValue(initialKeyword);
    setErrorMessage("");
    setTouched(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          maxWidth: { xs: "90%", sm: "400px", md: "500px" },
          m: "10% auto 0 auto",
        }}
        data-testid="manage-keywords-edit-modal"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ keyword: inputValue, keywordID });
            resetForm();
          }}
          autoComplete="false"
          autoCorrect="false"
        >
          <CardContent>
            <Typography variant="h6" sx={{ mb: 2.5 }}>
              Edit Keyword - {initialKeyword}
            </Typography>
            <TextField
              fullWidth
              autoFocus
              error={Boolean(touched && errorMessage)}
              helperText={(touched && errorMessage) || " "} // the || " " prevents a layout shift
              label="Keyword Name"
              onChange={handleChange}
              value={inputValue}
            />
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <Button
              onClick={() => {
                handleClose();
                resetForm();
              }}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={Boolean(!touched || errorMessage)}
            >
              Save
            </Button>
          </Box>
        </form>
      </Card>
    </Modal>
  );
};

EditKeywordModal.propTypes = {
  keywords: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  keywordToEdit: PropTypes.shape({
    keyword: PropTypes.string.isRequired,
    keywordID: PropTypes.string.isRequired,
  }),
  open: PropTypes.bool.isRequired,
};

export default EditKeywordModal;
